export default __webpack_public_path__ + "96daac80d01a1e779974196f495f64df.woff2";